module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.cdata.total.income || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("计价数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.cdata.total.num || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("转化率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.cdata.total.clickok_per || '0') + "%")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    attrs: {
      "sm": 16,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "yesterday",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.oneKey(0)
      }
    }
  }, [_vm._v("一键分配收入")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "所有投放位置",
      "clearable": ""
    },
    on: {
      "change": _vm.placementFilter
    },
    model: {
      value: (_vm.pText),
      callback: function($$v) {
        _vm.pText = $$v
      },
      expression: "pText"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 8,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown xs24",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": v
      }
    }, [_vm._v(_vm._s(v))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "data",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "row-key": "creative_id",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "creative_id"
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "placement",
            "label": "投放位置",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "theme",
            "label": "产品分类",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type",
            "label": "计价方式",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "num",
            "label": "计价数",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(s) {
              return [_c('div', {
                class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
              }, [_vm._v(_vm._s(s.row.num))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "产品收入",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_pv",
            "label": "点击pv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "label": "点击uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "点击成功uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "unit",
            "label": "点击单价 ",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_per",
            "label": "转化率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.click_per + '%'))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "150px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.geng(scope.row)
                  }
                }
              }, [_vm._v("更新")]), _vm._v(" "), ((_vm.dateVal[0] === _vm.dateVal[1]) && scope.row.adminurl != '') ? _c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.jump(scope.row.adminurl)
                  }
                }
              }, [_vm._v("后台")]) : _vm._e()]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 45878414)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creative_id",
      "label": "ID",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placement",
      "label": "投放位置",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "theme",
      "label": "产品分类",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "计价方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "",
      "prop": "num",
      "label": "计价数",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('div', {
          class: s.row.num == 0 && s.row.clickok_uv != 0 ? 'noNum' : ''
        }, [_vm._v(_vm._s(s.row.num))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_price - 0) - (b.click_price - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_pv",
      "label": "点击pv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_pv - 0) - (b.click_pv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功uv",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "产品单价 ",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.unit - 0) - (b.unit - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.unit != scope.row.avg_unit ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.unit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "转化率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_per - 0) - (b.click_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.click_per + '%'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.dateVal[0] === _vm.dateVal[1]) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.geng(scope.row)
            }
          }
        }, [_vm._v("更新")]) : _vm._e(), _vm._v(" "), ((_vm.dateVal[0] === _vm.dateVal[1]) && scope.row.adminurl != '') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.jump(scope.row.adminurl)
            }
          }
        }, [_vm._v("后台")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "更新产品数据",
      "visible": _vm.editDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.choose
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计价单价",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.choose.unit),
      callback: function($$v) {
        _vm.$set(_vm.choose, "unit", $$v)
      },
      expression: "choose.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计价数",
      "label-width": '120px'
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pupdate($event)
      }
    },
    model: {
      value: (_vm.choose.num),
      callback: function($$v) {
        _vm.$set(_vm.choose, "num", $$v)
      },
      expression: "choose.num"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pupdate
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分配收入记录",
      "visible": _vm.logDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": '150px'
    }
  }, [_vm._v(_vm._s(this.dateVal[0]))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "分配记录",
      "width": '350px'
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626d1632"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adData/pData.vue
// module id = 1108
// module chunks = 2